<div class="login-page d-flex flex-column min-vh-100">
	<div class="login-main d-flex">

		<!-- Left: cover photo -->
		<div class="login-photo portal-brand-fill" [style.background-image]="coverUrl ? 'url(' + coverUrl + ')' : null">
			<div class="portal-logo logo-box"><portal-brand-logo></portal-brand-logo></div>
		</div>

		<!-- Right: form -->
		<div class="login-form-panel d-flex flex-column align-items-center justify-content-center">
			<form class="login-form-inner d-flex flex-column" (ngSubmit)="submit()">
				<div class="portal-logo login-company-logo"><portal-brand-logo></portal-brand-logo></div>

				<h1 class="login-heading">Login to your project</h1>

				<div class="form-group">
					<label for="email">E-mail</label>
					<input id="email" class="form-control" type="email" name="email" placeholder="example@example.com"
						[(ngModel)]="email" autocomplete="username" />
				</div>

				<div class="form-group">
					<label for="password">Password</label>
					<input id="password" class="form-control" type="password" name="password" placeholder="Enter Password"
						[(ngModel)]="password" autocomplete="current-password" />
				</div>

				<div class="login-error portal-error" *ngIf="error">{{ error }}</div>

				<button type="submit" class="btn btn-primary btn-block" [disabled]="loading">
					{{ loading ? 'Logging in…' : 'Log in' }}
				</button>

				<div class="login-options d-flex align-items-center justify-content-between">
					<label class="login-checkbox d-flex align-items-center gap-1">
						<input type="checkbox" name="stay" [(ngModel)]="staySignedIn" />
						Stay signed in
					</label>
					<button type="button" class="btn btn-link" routerLink="/forgot-password">Forgot Password?</button>
				</div>
			</form>
		</div>
	</div>

	<!-- Footer bar -->
	<div class="login-footer d-flex align-items-center justify-content-between flex-wrap">
		<div class="powered-by d-flex align-items-center gap-2">
			<span>Powered by</span>
			<img class="powered-logo powered-logo-light" src="assets/img/logo/wequote-text-dark.png" alt="WeQuote" />
			<img class="powered-logo powered-logo-dark" src="assets/img/logo/wequote.svg" alt="WeQuote" />
		</div>
		<div class="footer-links d-flex gap-4">
			<button type="button" class="portal-link-button" (click)="termsModal.open()">Terms of Use</button>
			<button type="button" class="portal-link-button" (click)="privacyModal.open()">Privacy Notice</button>
		</div>
	</div>
</div>

<!-- Read-only policy popups, opened from the footer. -->
<portal-terms-modal #termsModal></portal-terms-modal>
<portal-privacy-modal #privacyModal></portal-privacy-modal>
